/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const sessionPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const sessionPageResponseOutputItemsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const sessionPageResponseOutputItemsItemUserDisplayNameMax = 200;

export const sessionPageResponseOutputItemsItemUserVersionExclusiveMin = 0;
export const sessionPageResponseOutputItemsItemUserVersionMax = 9007199254740991;

export const sessionPageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionPageResponseOutputItemsItemLastActivityAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionPageResponseOutputItemsItemAbsoluteExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionPageResponseOutputItemsItemIdleExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionPageResponseOutputItemsItemDeviceContextBrowserFamilyMax = 80;

export const sessionPageResponseOutputItemsItemDeviceContextOsFamilyMax = 80;

export const sessionPageResponseOutputNextCursorOneMax = 512;

export const sessionPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const SessionPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(sessionPageResponseOutputItemsItemIdRegExp),
      user: zod.object({
        id: zod.uuid().regex(sessionPageResponseOutputItemsItemUserIdRegExp),
        displayName: zod.string().min(1).max(sessionPageResponseOutputItemsItemUserDisplayNameMax),
        corporateState: zod.enum(['active', 'deactivated']),
        role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
        version: zod
          .int()
          .gt(sessionPageResponseOutputItemsItemUserVersionExclusiveMin)
          .max(sessionPageResponseOutputItemsItemUserVersionMax),
      }),
      createdAt: zod.iso
        .datetime({ offset: true })
        .regex(sessionPageResponseOutputItemsItemCreatedAtRegExp),
      lastActivityAt: zod.iso
        .datetime({ offset: true })
        .regex(sessionPageResponseOutputItemsItemLastActivityAtRegExp),
      absoluteExpiresAt: zod.iso
        .datetime({ offset: true })
        .regex(sessionPageResponseOutputItemsItemAbsoluteExpiresAtRegExp),
      idleExpiresAt: zod.iso
        .datetime({ offset: true })
        .regex(sessionPageResponseOutputItemsItemIdleExpiresAtRegExp),
      deviceContext: zod.object({
        browserFamily: zod
          .string()
          .min(1)
          .max(sessionPageResponseOutputItemsItemDeviceContextBrowserFamilyMax),
        osFamily: zod
          .string()
          .min(1)
          .max(sessionPageResponseOutputItemsItemDeviceContextOsFamilyMax),
        category: zod.enum(['phone', 'tablet', 'desktop', 'unknown']),
      }),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(sessionPageResponseOutputNextCursorOneMax)
      .regex(sessionPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type SessionPageResponseOutput = zod.input<typeof SessionPageResponseOutput>;
export type SessionPageResponseOutputOutput = zod.output<typeof SessionPageResponseOutput>;
